/* eslint-disable */
export default {
  header: 'Communiquer avec le service de soutien',
  toggleTitle: '1. Activez le mode de suivi des erreurs.',
  toggleDescription:
    'Cela nous aidera à localiser la source des problèmes que vous rencontrez, mais cela pourrait affecter légèrement la performance de votre application.',
  downloadTitle:
    '2. Téléchargez le journal d’erreurs lorsque vous avez reproduit le problème.',
  downloadButton: 'Télécharger',
  downloadDisabledTitle:
    'Activez le mode de suivi des erreurs avant de pouvoir télécharger le journal des erreurs.',
  sendTitle: '3. Envoyez le journal à l’équipe de soutien.',
  createSupportTicket: 'Créez un ticket de soutien',
  sendDescription:
    ' pour communiquer avec notre équipe de soutien. Envoyez ensuite le journal à l’équipe de soutien pour dépannage.',
  privacyNotice:
    'En téléchargeant et en nous envoyant le journal, vous acceptez d’autoriser RingCentral à accéder à certains renseignements relatifs aux journaux aux fins de résolution de problèmes et de gestion des erreurs. Pour obtenir plus de renseignements sur la manière dont RingCentral traite les données personnelles, veuillez consulter nos ',
  privacyNoticeLink: 'Conditions d’utilisation',
  and: ' et notre ',
  privacyNoticeEnd: 'Avis de confidentialité.',
  needLeavePage:
    'Vous pouvez quitter cette page pendant que le suivi des erreurs est en cours. Lorsque vous aurez reproduit le problème, revenez à cette page et téléchargez les fichiers journaux.',
  downloading: 'Téléchargement',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
